import { doGet } from 'src/api/axios-config';
import { ApiRoute } from 'src/constants';
import type { IBank, IBankStat } from 'src/interfaces';

export async function fetchMausoleumBanks(mausoleumId: string): Promise<IBank[] | null> {
  try {
    const result = await doGet<IBank[]>(ApiRoute.MAUSOLEUM_BANKS(mausoleumId));
    return result.data || null;
  } catch (err: any) {
    console.log(err);
    return null;
  }
}

export async function fetchBankStat(bankId: string): Promise<IBankStat | null> {
  try {
    const result = await doGet<IBankStat>(ApiRoute.BANKS(bankId));
    return result.data || null;
  } catch (err: any) {
    console.log(err);
    return null;
  }
}
